"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadCompanyCallSourceLogoType = exports.ListUsersForCompanyUserTypes = exports.ListGroupAvailabilityStatus = exports.ListCompanyApiKeysExpires = exports.CreateCompanyAssetOperationType = exports.CompaniesApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class CompaniesApi extends runtime.BaseAPI {
    /**
     */
    acquireEmbedReportsSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling acquireEmbedReportsSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/reports/~acquire-embed-session`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiAcquireEmbedReportsSessionResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    acquireEmbedReportsSession(companyCodeOrSid, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.acquireEmbedReportsSessionRaw({ companyCodeOrSid: companyCodeOrSid, body: body });
            return yield response.value();
        });
    }
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    addGroupUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling addGroupUser.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling addGroupUser.');
            }
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling addGroupUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    addGroupUser(companyCodeOrSid, groupName, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
        });
    }
    /**
     * Create batch of companies. This endpoint fails forward even if some entries fail.See the single Create Company endpoint for details about required fields.
     * Batch create company
     */
    batchCreateCompanyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/~batch`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiBatchCreateCompanyRequestToJSON)(requestParameters.streemApiBatchCreateCompanyRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiBatchCreateCompanyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create batch of companies. This endpoint fails forward even if some entries fail.See the single Create Company endpoint for details about required fields.
     * Batch create company
     */
    batchCreateCompany(streemApiBatchCreateCompanyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.batchCreateCompanyRaw({ streemApiBatchCreateCompanyRequest: streemApiBatchCreateCompanyRequest });
            return yield response.value();
        });
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    cancelGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelGroupReservation.');
            }
            if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
                throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling cancelGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/cancel`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    cancelGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
        });
    }
    /**
     */
    cancelQueuedGroupReservationsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelQueuedGroupReservations.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelQueuedGroupReservations.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/~cancel-all`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    cancelQueuedGroupReservations(companyCodeOrSid, groupName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelQueuedGroupReservationsRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        });
    }
    /**
     * Change the `external_user_id`, which should be unique in the scope of the specified Company
     * Change User ID
     */
    changeExternalUserIdRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling changeExternalUserId.');
            }
            if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
                throw new runtime.RequiredError('externalUserId', 'Required parameter requestParameters.externalUserId was null or undefined when calling changeExternalUserId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/users/{external_user_id}/~change-user-id`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"external_user_id"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiChangeExternalUserIdRequestToJSON)(requestParameters.streemApiChangeExternalUserIdRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiChangeExternalUserIdResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Change the `external_user_id`, which should be unique in the scope of the specified Company
     * Change User ID
     */
    changeExternalUserId(companyCodeOrSid, externalUserId, streemApiChangeExternalUserIdRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.changeExternalUserIdRaw({ companyCodeOrSid: companyCodeOrSid, externalUserId: externalUserId, streemApiChangeExternalUserIdRequest: streemApiChangeExternalUserIdRequest });
            return yield response.value();
        });
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    confirmMatchedGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling confirmMatchedGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling confirmMatchedGroupReservation.');
            }
            if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
                throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling confirmMatchedGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/confirm`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    confirmMatchedGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.confirmMatchedGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
        });
    }
    /**
     */
    createCallSourceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCallSource.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/call-source`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateCompanyCallSourceRequestToJSON)(requestParameters.streemApiCreateCompanyCallSourceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateCompanyCallSourceResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    createCallSource(companyCodeOrSid, streemApiCreateCompanyCallSourceRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateCompanyCallSourceRequest: streemApiCreateCompanyCallSourceRequest });
            return yield response.value();
        });
    }
    /**
     * Create a new Company.  Provide `parent_company_sid` to create a Sub-Company.  The number of Sub-Companies allowed is limited to 10 initially, but you can request to have this limit increased.  Sub-Companies cannot themselves have Sub-Companies.
     * Create Company
     */
    createCompanyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateCompanyRequestToJSON)(requestParameters.streemApiCreateCompanyRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateCompanyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new Company.  Provide `parent_company_sid` to create a Sub-Company.  The number of Sub-Companies allowed is limited to 10 initially, but you can request to have this limit increased.  Sub-Companies cannot themselves have Sub-Companies.
     * Create Company
     */
    createCompany(streemApiCreateCompanyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCompanyRaw({ streemApiCreateCompanyRequest: streemApiCreateCompanyRequest });
            return yield response.value();
        });
    }
    /**
     * Create a new API Key for the specified Company
     * Create API Key
     */
    createCompanyApiKeyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyApiKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/api-keys`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateCompanyApiKeyRequestToJSON)(requestParameters.streemApiCreateCompanyApiKeyRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateCompanyApiKeyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new API Key for the specified Company
     * Create API Key
     */
    createCompanyApiKey(companyCodeOrSid, streemApiCreateCompanyApiKeyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCompanyApiKeyRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateCompanyApiKeyRequest: streemApiCreateCompanyApiKeyRequest });
            return yield response.value();
        });
    }
    /**
     * Upload a Company asset
     * Upload Asset
     */
    createCompanyAssetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyAsset.');
            }
            if (requestParameters.type === null || requestParameters.type === undefined) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling createCompanyAsset.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/assets/{type}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateCompanyAssetRequestToJSON)(requestParameters.streemApiCreateCompanyAssetRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateCompanyAssetResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Upload a Company asset
     * Upload Asset
     */
    createCompanyAsset(companyCodeOrSid, type, streemApiCreateCompanyAssetRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCompanyAssetRaw({ companyCodeOrSid: companyCodeOrSid, type: type, streemApiCreateCompanyAssetRequest: streemApiCreateCompanyAssetRequest });
            return yield response.value();
        });
    }
    /**
     * Create the configuration for post call outcomes dialog
     * Create a configuration for Room Outcomes
     */
    createCompanyRoomOutcomeConfigRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyRoomOutcomeConfig.');
            }
            if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
                throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling createCompanyRoomOutcomeConfig.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/room-outcome-config/{fileName}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters.fileName))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateCompanyRoomOutcomeConfigRequestToJSON)(requestParameters.streemApiCreateCompanyRoomOutcomeConfigRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Create the configuration for post call outcomes dialog
     * Create a configuration for Room Outcomes
     */
    createCompanyRoomOutcomeConfig(companyCodeOrSid, fileName, streemApiCreateCompanyRoomOutcomeConfigRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.createCompanyRoomOutcomeConfigRaw({ companyCodeOrSid: companyCodeOrSid, fileName: fileName, streemApiCreateCompanyRoomOutcomeConfigRequest: streemApiCreateCompanyRoomOutcomeConfigRequest });
        });
    }
    /**
     * Create a user for log-in for this Company
     * Create a user
     */
    createCompanyUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createCompanyUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateCompanyUserRequestToJSON)(requestParameters.streemApiCreateCompanyUserRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateCompanyUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a user for log-in for this Company
     * Create a user
     */
    createCompanyUser(companyCodeOrSid, streemApiCreateCompanyUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCompanyUserRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateCompanyUserRequest: streemApiCreateCompanyUserRequest });
            return yield response.value();
        });
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    createGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateGroupRequestToJSON)(requestParameters.streemApiCreateGroupRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateGroupResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    createGroup(companyCodeOrSid, streemApiCreateGroupRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createGroupRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateGroupRequest: streemApiCreateGroupRequest });
            return yield response.value();
        });
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    createGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling createGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateGroupReservationRequestToJSON)(requestParameters.streemApiCreateGroupReservationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateGroupReservationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    createGroupReservation(companyCodeOrSid, groupName, streemApiCreateGroupReservationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiCreateGroupReservationRequest: streemApiCreateGroupReservationRequest });
            return yield response.value();
        });
    }
    /**
     * Create an Invitation from/to the provided Users
     * Create Invitation
     */
    createInvitationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createInvitation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/invitations`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateInvitationRequestToJSON)(requestParameters.streemApiCreateInvitationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateInvitationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create an Invitation from/to the provided Users
     * Create Invitation
     */
    createInvitation(companyCodeOrSid, streemApiCreateInvitationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createInvitationRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateInvitationRequest: streemApiCreateInvitationRequest });
            return yield response.value();
        });
    }
    /**
     * Requests all Personally Identifiable Information (PII) associated with a user
     * Create user PII request
     */
    createPiiRequestRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createPiiRequest.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/pii-requests`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreatePiiRequestRequestToJSON)(requestParameters.streemApiCreatePiiRequestRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreatePiiRequestResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Requests all Personally Identifiable Information (PII) associated with a user
     * Create user PII request
     */
    createPiiRequest(companyCodeOrSid, streemApiCreatePiiRequestRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createPiiRequestRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreatePiiRequestRequest: streemApiCreatePiiRequestRequest });
            return yield response.value();
        });
    }
    /**
     */
    deleteCallSourceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCallSource.');
            }
            if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
                throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling deleteCallSource.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    deleteCallSource(companyCodeOrSid, callSourceSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid });
        });
    }
    /**
     * Deactivate Company/Users and optionally delete assets
     * Deactivate Company and assets
     */
    deleteCompanyAndAssetsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanyAndAssets.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deactivate Company/Users and optionally delete assets
     * Deactivate Company and assets
     */
    deleteCompanyAndAssets(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteCompanyAndAssetsRaw({ companyCodeOrSid: companyCodeOrSid });
        });
    }
    /**
     * Delete Company Room Outcome Configuration for a specific Company
     * Delete Company Room Outcome Configuration
     */
    deleteCompanyRoomOutcomeConfigRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanyRoomOutcomeConfig.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/room-outcome-config`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete Company Room Outcome Configuration for a specific Company
     * Delete Company Room Outcome Configuration
     */
    deleteCompanyRoomOutcomeConfig(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteCompanyRoomOutcomeConfigRaw({ companyCodeOrSid: companyCodeOrSid });
        });
    }
    /**
     * Delete a Setting for the specified Company, resetting it back to the default
     * Delete Setting
     */
    deleteCompanySettingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanySetting.');
            }
            if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
                throw new runtime.RequiredError('settingName', 'Required parameter requestParameters.settingName was null or undefined when calling deleteCompanySetting.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/settings/{setting_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiDeleteCompanySettingResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Delete a Setting for the specified Company, resetting it back to the default
     * Delete Setting
     */
    deleteCompanySetting(companyCodeOrSid, settingName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCompanySettingRaw({ companyCodeOrSid: companyCodeOrSid, settingName: settingName });
            return yield response.value();
        });
    }
    /**
     * Deletes a specified tag for the specified Company
     * Delete Company Tag
     */
    deleteCompanyTagRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteCompanyTag.');
            }
            if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
                throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling deleteCompanyTag.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/tags/{tag_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a specified tag for the specified Company
     * Delete Company Tag
     */
    deleteCompanyTag(companyCodeOrSid, tagName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteCompanyTagRaw({ companyCodeOrSid: companyCodeOrSid, tagName: tagName });
        });
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    deleteGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroup.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    deleteGroup(companyCodeOrSid, groupName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        });
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    deleteGroupUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroupUser.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroupUser.');
            }
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteGroupUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    deleteGroupUser(companyCodeOrSid, groupName, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
        });
    }
    /**
     * Returns one or more links to download audit logs for the given YYYY-MM-DD day. The file contains all audit events occurring on that day in JSON format.
     * Fetch link(s) to audit logs for a given day
     */
    getAuditLogRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getAuditLog.');
            }
            const queryParameters = {};
            if (requestParameters.day !== undefined) {
                queryParameters['day'] = requestParameters.day.toISOString().substr(0, 10);
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/audit-logs`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetAuditLogsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Returns one or more links to download audit logs for the given YYYY-MM-DD day. The file contains all audit events occurring on that day in JSON format.
     * Fetch link(s) to audit logs for a given day
     */
    getAuditLog(companyCodeOrSid, day) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAuditLogRaw({ companyCodeOrSid: companyCodeOrSid, day: day });
            return yield response.value();
        });
    }
    /**
     */
    getCallSourceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCallSource.');
            }
            if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
                throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling getCallSource.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyCallSourceResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    getCallSource(companyCodeOrSid, callSourceSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid });
            return yield response.value();
        });
    }
    /**
     */
    getCallSourcesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCallSources.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/call-source`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyCallSourcesResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    getCallSources(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCallSourcesRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get info for a specific Company
     * Get Company
     */
    getCompanyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompany.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get info for a specific Company
     * Get Company
     */
    getCompany(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompanyRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get an API Key by `api_key_id` for the specified Company
     * Get API Key
     */
    getCompanyApiKeyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyApiKey.');
            }
            if (requestParameters.apiKeyId === null || requestParameters.apiKeyId === undefined) {
                throw new runtime.RequiredError('apiKeyId', 'Required parameter requestParameters.apiKeyId was null or undefined when calling getCompanyApiKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/api-keys/{api_key_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"api_key_id"}}`, encodeURIComponent(String(requestParameters.apiKeyId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyApiKeyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get an API Key by `api_key_id` for the specified Company
     * Get API Key
     */
    getCompanyApiKey(companyCodeOrSid, apiKeyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompanyApiKeyRaw({ companyCodeOrSid: companyCodeOrSid, apiKeyId: apiKeyId });
            return yield response.value();
        });
    }
    /**
     * Get the Call Log for the specified Company, which are all calls made by Users of the Company
     * Get Call Log
     */
    getCompanyCallLogRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyCallLog.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            if (requestParameters.filter !== undefined) {
                queryParameters['filter'] = requestParameters.filter;
            }
            if (requestParameters.startTime !== undefined) {
                queryParameters['start_time'] = requestParameters.startTime.toISOString();
            }
            if (requestParameters.endTime !== undefined) {
                queryParameters['end_time'] = requestParameters.endTime.toISOString();
            }
            if (requestParameters.groupNames) {
                queryParameters['group_names'] = requestParameters.groupNames;
            }
            if (requestParameters.callStatuses) {
                queryParameters['call_statuses'] = requestParameters.callStatuses;
            }
            if (requestParameters.hasRoomNotes !== undefined) {
                queryParameters['has_room_notes'] = requestParameters.hasRoomNotes;
            }
            if (requestParameters.callSourceCodes) {
                queryParameters['call_source_codes'] = requestParameters.callSourceCodes;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/call-log`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyCallLogResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the Call Log for the specified Company, which are all calls made by Users of the Company
     * Get Call Log
     */
    getCompanyCallLog(companyCodeOrSid, pageSize, pageToken, filter, startTime, endTime, groupNames, callStatuses, hasRoomNotes, callSourceCodes) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompanyCallLogRaw({ companyCodeOrSid: companyCodeOrSid, pageSize: pageSize, pageToken: pageToken, filter: filter, startTime: startTime, endTime: endTime, groupNames: groupNames, callStatuses: callStatuses, hasRoomNotes: hasRoomNotes, callSourceCodes: callSourceCodes });
            return yield response.value();
        });
    }
    /**
     * Get the current Identity Provider for this Company
     * Get Identity Provider
     */
    getCompanyIdentityProviderRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyIdentityProvider.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/identity-provider`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyIdentityProviderResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the current Identity Provider for this Company
     * Get Identity Provider
     */
    getCompanyIdentityProvider(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompanyIdentityProviderRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get the current License associated with this Company
     * Get Company License
     */
    getCompanyLicenseRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyLicense.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/license`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyLicenseResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the current License associated with this Company
     * Get Company License
     */
    getCompanyLicense(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompanyLicenseRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get Company Room Outcome Configuration for a specific Company
     * Get Company Room Outcome Configuration
     */
    getCompanyRoomOutcomeConfigRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyRoomOutcomeConfig.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/room-outcome-config`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyRoomOutcomeConfigResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get Company Room Outcome Configuration for a specific Company
     * Get Company Room Outcome Configuration
     */
    getCompanyRoomOutcomeConfig(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompanyRoomOutcomeConfigRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get a specified tag and its values for the specified Company
     * Get Company Tag
     */
    getCompanyTagRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getCompanyTag.');
            }
            if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
                throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling getCompanyTag.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/tags/{tag_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCompanyTagResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a specified tag and its values for the specified Company
     * Get Company Tag
     */
    getCompanyTag(companyCodeOrSid, tagName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompanyTagRaw({ companyCodeOrSid: companyCodeOrSid, tagName: tagName });
            return yield response.value();
        });
    }
    /**
     * Returns the company associated with this account
     * Get Current Company
     */
    getCurrentCompanyRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/current`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetCurrentCompanyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Returns the company associated with this account
     * Get Current Company
     */
    getCurrentCompany() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCurrentCompanyRaw();
            return yield response.value();
        });
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    getGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroup.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetGroupResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    getGroup(companyCodeOrSid, groupName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
            return yield response.value();
        });
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    getGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservation.');
            }
            if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
                throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling getGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetGroupReservationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    getGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
            return yield response.value();
        });
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    getGroupReservationWaitTimeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservationWaitTime.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservationWaitTime.');
            }
            if (requestParameters.priority === null || requestParameters.priority === undefined) {
                throw new runtime.RequiredError('priority', 'Required parameter requestParameters.priority was null or undefined when calling getGroupReservationWaitTime.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{priority}/wait_time`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"priority"}}`, encodeURIComponent(String(requestParameters.priority))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetGroupReservationWaitTimeResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    getGroupReservationWaitTime(companyCodeOrSid, groupName, priority) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGroupReservationWaitTimeRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, priority: priority });
            return yield response.value();
        });
    }
    /**
     * Get or create a User for this Company with the provided `external_user_id`, returning their internal `user_sid`
     * Get/Create User
     */
    getOrCreateUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getOrCreateUser.');
            }
            if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
                throw new runtime.RequiredError('externalUserId', 'Required parameter requestParameters.externalUserId was null or undefined when calling getOrCreateUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/users/{external_user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"external_user_id"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiGetOrCreateUserRequestToJSON)(requestParameters.streemApiGetOrCreateUserRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetOrCreateUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get or create a User for this Company with the provided `external_user_id`, returning their internal `user_sid`
     * Get/Create User
     */
    getOrCreateUser(companyCodeOrSid, externalUserId, streemApiGetOrCreateUserRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrCreateUserRaw({ companyCodeOrSid: companyCodeOrSid, externalUserId: externalUserId, streemApiGetOrCreateUserRequest: streemApiGetOrCreateUserRequest });
            return yield response.value();
        });
    }
    /**
     * Get the public login configuration, determining how to login to this company
     * Get Public Login Config
     */
    getPublicLoginConfigurationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getPublicLoginConfiguration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/public-login-configuration`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetPublicLoginConfigurationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the public login configuration, determining how to login to this company
     * Get Public Login Config
     */
    getPublicLoginConfiguration(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPublicLoginConfigurationRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get any setting name\'s definition
     * Get Setting Definition
     */
    getSettingDefinitionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getSettingDefinition.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/~default-setting`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiGetSettingDefinitionRequestToJSON)(requestParameters.streemApiGetSettingDefinitionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetSettingDefinitionResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get any setting name\'s definition
     * Get Setting Definition
     */
    getSettingDefinition(companyCodeOrSid, streemApiGetSettingDefinitionRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSettingDefinitionRaw({ companyCodeOrSid: companyCodeOrSid, streemApiGetSettingDefinitionRequest: streemApiGetSettingDefinitionRequest });
            return yield response.value();
        });
    }
    /**
     * Get User by `external_user_id`, which should be unique in the scope of the specified Company
     * Get User By External User Id
     */
    getUserByExternalUserIdRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getUserByExternalUserId.');
            }
            if (requestParameters.externalUserId === null || requestParameters.externalUserId === undefined) {
                throw new runtime.RequiredError('externalUserId', 'Required parameter requestParameters.externalUserId was null or undefined when calling getUserByExternalUserId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/users/{external_user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"external_user_id"}}`, encodeURIComponent(String(requestParameters.externalUserId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetUserByExternalUserIdResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get User by `external_user_id`, which should be unique in the scope of the specified Company
     * Get User By External User Id
     */
    getUserByExternalUserId(companyCodeOrSid, externalUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserByExternalUserIdRaw({ companyCodeOrSid: companyCodeOrSid, externalUserId: externalUserId });
            return yield response.value();
        });
    }
    /**
     * List companies or sub companies. Can filter based on parent company sid, active status, name, and/or company code.
     * List Companies
     */
    listCompaniesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            if (requestParameters.sort !== undefined) {
                queryParameters['sort'] = requestParameters.sort;
            }
            if (requestParameters.filter !== undefined) {
                queryParameters['filter'] = requestParameters.filter;
            }
            if (requestParameters.active !== undefined) {
                queryParameters['active'] = requestParameters.active;
            }
            if (requestParameters.parentCompanySid !== undefined) {
                queryParameters['parent_company_sid'] = requestParameters.parentCompanySid;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListCompaniesResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List companies or sub companies. Can filter based on parent company sid, active status, name, and/or company code.
     * List Companies
     */
    listCompanies(pageSize, pageToken, sort, filter, active, parentCompanySid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listCompaniesRaw({ pageSize: pageSize, pageToken: pageToken, sort: sort, filter: filter, active: active, parentCompanySid: parentCompanySid });
            return yield response.value();
        });
    }
    /**
     * List API keys for the specified Company
     * List API Keys
     */
    listCompanyApiKeysRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanyApiKeys.');
            }
            const queryParameters = {};
            if (requestParameters.includeExpired !== undefined) {
                queryParameters['include_expired'] = requestParameters.includeExpired;
            }
            if (requestParameters.expires !== undefined) {
                queryParameters['expires'] = requestParameters.expires;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/api-keys`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListCompanyApiKeysResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List API keys for the specified Company
     * List API Keys
     */
    listCompanyApiKeys(companyCodeOrSid, includeExpired, expires, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listCompanyApiKeysRaw({ companyCodeOrSid: companyCodeOrSid, includeExpired: includeExpired, expires: expires, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * Get those settings for the specified Company that are available without authentication
     * Get Public Settings
     */
    listCompanyPublicSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanyPublicSettings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/public-settings`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListCompanyPublicSettingsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get those settings for the specified Company that are available without authentication
     * Get Public Settings
     */
    listCompanyPublicSettings(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listCompanyPublicSettingsRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get a list of Settings for the specified Company
     * Get Settings
     */
    listCompanySettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanySettings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/settings`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListCompanySettingsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a list of Settings for the specified Company
     * Get Settings
     */
    listCompanySettings(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listCompanySettingsRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * Get all tags and their values for the specified Company
     * Get Company Tags
     */
    listCompanyTagsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listCompanyTags.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/tags`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListCompanyTagsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get all tags and their values for the specified Company
     * Get Company Tags
     */
    listCompanyTags(companyCodeOrSid, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listCompanyTagsRaw({ companyCodeOrSid: companyCodeOrSid, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    listGroupAvailabilityRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupAvailability.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupAvailability.');
            }
            const queryParameters = {};
            if (requestParameters.status !== undefined) {
                queryParameters['status'] = requestParameters.status;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/availability`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListGroupAvailabilityRequestFromJSON)(jsonValue));
        });
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    listGroupAvailability(companyCodeOrSid, groupName, status, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGroupAvailabilityRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, status: status, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    listGroupUsersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupUsers.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupUsers.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListGroupUsersResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    listGroupUsers(companyCodeOrSid, groupName, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGroupUsersRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    listGroupsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroups.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListGroupsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    listGroups(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGroupsRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    listUserGroupsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listUserGroups.');
            }
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling listUserGroups.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListUserGroupsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    listUserGroups(companyCodeOrSid, userId, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listUserGroupsRaw({ companyCodeOrSid: companyCodeOrSid, userId: userId, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * Get all Users associated with the specified Company
     * Get Users
     */
    listUsersForCompanyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listUsersForCompany.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            if (requestParameters.active !== undefined) {
                queryParameters['active'] = requestParameters.active;
            }
            if (requestParameters.deleted !== undefined) {
                queryParameters['deleted'] = requestParameters.deleted;
            }
            if (requestParameters.filter !== undefined) {
                queryParameters['filter'] = requestParameters.filter;
            }
            if (requestParameters.sort !== undefined) {
                queryParameters['sort'] = requestParameters.sort;
            }
            if (requestParameters.userTypes) {
                queryParameters['user_types'] = requestParameters.userTypes;
            }
            if (requestParameters.includeAvailabilityStatus !== undefined) {
                queryParameters['include_availability_status'] = requestParameters.includeAvailabilityStatus;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListCompanyUsersResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get all Users associated with the specified Company
     * Get Users
     */
    listUsersForCompany(companyCodeOrSid, pageSize, pageToken, active, deleted, filter, sort, userTypes, includeAvailabilityStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listUsersForCompanyRaw({ companyCodeOrSid: companyCodeOrSid, pageSize: pageSize, pageToken: pageToken, active: active, deleted: deleted, filter: filter, sort: sort, userTypes: userTypes, includeAvailabilityStatus: includeAvailabilityStatus });
            return yield response.value();
        });
    }
    /**
     */
    refreshEmbedReportsSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling refreshEmbedReportsSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/reports/~refresh-embed-session`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiRefreshEmbedReportsSessionRequestToJSON)(requestParameters.streemApiRefreshEmbedReportsSessionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiRefreshEmbedReportsSessionResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    refreshEmbedReportsSession(companyCodeOrSid, streemApiRefreshEmbedReportsSessionRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refreshEmbedReportsSessionRaw({ companyCodeOrSid: companyCodeOrSid, streemApiRefreshEmbedReportsSessionRequest: streemApiRefreshEmbedReportsSessionRequest });
            return yield response.value();
        });
    }
    /**
     * Revokes an API Key, which sets the `expires_at` date to now
     * Revoke API Key
     */
    revokeCompanyApiKeyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling revokeCompanyApiKey.');
            }
            if (requestParameters.apiKeyId === null || requestParameters.apiKeyId === undefined) {
                throw new runtime.RequiredError('apiKeyId', 'Required parameter requestParameters.apiKeyId was null or undefined when calling revokeCompanyApiKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/api-keys/{api_key_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"api_key_id"}}`, encodeURIComponent(String(requestParameters.apiKeyId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Revokes an API Key, which sets the `expires_at` date to now
     * Revoke API Key
     */
    revokeCompanyApiKey(companyCodeOrSid, apiKeyId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.revokeCompanyApiKeyRaw({ companyCodeOrSid: companyCodeOrSid, apiKeyId: apiKeyId });
        });
    }
    /**
     * Saves or updates the current License assigned to this Company
     * Save Company License
     */
    saveCompanyLicenseRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveCompanyLicense.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/license`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiSaveCompanyLicenseRequestToJSON)(requestParameters.streemApiSaveCompanyLicenseRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiSaveCompanyLicenseResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Saves or updates the current License assigned to this Company
     * Save Company License
     */
    saveCompanyLicense(companyCodeOrSid, streemApiSaveCompanyLicenseRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveCompanyLicenseRaw({ companyCodeOrSid: companyCodeOrSid, streemApiSaveCompanyLicenseRequest: streemApiSaveCompanyLicenseRequest });
            return yield response.value();
        });
    }
    /**
     * Save a Setting for the specified Company
     * Save Setting
     */
    saveCompanySettingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveCompanySetting.');
            }
            if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
                throw new runtime.RequiredError('settingName', 'Required parameter requestParameters.settingName was null or undefined when calling saveCompanySetting.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/settings/{setting_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiSaveCompanySettingRequestToJSON)(requestParameters.streemApiSaveCompanySettingRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiSaveCompanySettingResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Save a Setting for the specified Company
     * Save Setting
     */
    saveCompanySetting(companyCodeOrSid, settingName, streemApiSaveCompanySettingRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveCompanySettingRaw({ companyCodeOrSid: companyCodeOrSid, settingName: settingName, streemApiSaveCompanySettingRequest: streemApiSaveCompanySettingRequest });
            return yield response.value();
        });
    }
    /**
     * Creates/updates a specified tag for the specified Company
     * Save Company Tag
     */
    saveCompanyTagRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveCompanyTag.');
            }
            if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
                throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling saveCompanyTag.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/tags/{tag_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiSaveCompanyTagRequestToJSON)(requestParameters.streemApiSaveCompanyTagRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiSaveCompanyTagResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Creates/updates a specified tag for the specified Company
     * Save Company Tag
     */
    saveCompanyTag(companyCodeOrSid, tagName, streemApiSaveCompanyTagRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveCompanyTagRaw({ companyCodeOrSid: companyCodeOrSid, tagName: tagName, streemApiSaveCompanyTagRequest: streemApiSaveCompanyTagRequest });
            return yield response.value();
        });
    }
    /**
     */
    saveGroupReservationWaitMetricRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveGroupReservationWaitMetric.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/reservation-metrics`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemInternalApiSaveGroupAverageCallLengthRequestToJSON)(requestParameters.streemInternalApiSaveGroupAverageCallLengthRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemInternalApiSaveGroupAverageCallLengthResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    saveGroupReservationWaitMetric(companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveGroupReservationWaitMetricRaw({ companyCodeOrSid: companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest: streemInternalApiSaveGroupAverageCallLengthRequest });
            return yield response.value();
        });
    }
    /**
     * List all Companies that have a member with the given email
     * List Companies For User Email
     */
    searchCompaniesForUserEmailRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/user-email-search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiSearchCompaniesForUserEmailRequestToJSON)(requestParameters.streemApiSearchCompaniesForUserEmailRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiSearchCompaniesForUserEmailResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List all Companies that have a member with the given email
     * List Companies For User Email
     */
    searchCompaniesForUserEmail(streemApiSearchCompaniesForUserEmailRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchCompaniesForUserEmailRaw({ streemApiSearchCompaniesForUserEmailRequest: streemApiSearchCompaniesForUserEmailRequest });
            return yield response.value();
        });
    }
    /**
     * Update certain properties of the specified Company
     * Update Company
     */
    updateCompanyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateCompany.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateCompanyRequestToJSON)(requestParameters.streemApiUpdateCompanyRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateCompanyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update certain properties of the specified Company
     * Update Company
     */
    updateCompany(companyCodeOrSid, streemApiUpdateCompanyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCompanyRaw({ companyCodeOrSid: companyCodeOrSid, streemApiUpdateCompanyRequest: streemApiUpdateCompanyRequest });
            return yield response.value();
        });
    }
    /**
     */
    updateCompanyCallSourceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateCompanyCallSource.');
            }
            if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
                throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling updateCompanyCallSource.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateCompanyCallSourceRequestToJSON)(requestParameters.streemApiUpdateCompanyCallSourceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateCompanyCallSourceResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    updateCompanyCallSource(companyCodeOrSid, callSourceSid, streemApiUpdateCompanyCallSourceRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCompanyCallSourceRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid, streemApiUpdateCompanyCallSourceRequest: streemApiUpdateCompanyCallSourceRequest });
            return yield response.value();
        });
    }
    /**
     * Change the current Identity Provider for this Company.  WARNING: this will mean a clean slate of accounts, so previous logins will no longer work
     * Change Identity Provider
     */
    updateCompanyIdentityProviderRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateCompanyIdentityProvider.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/identity-provider`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateCompanyIdentityProviderRequestToJSON)(requestParameters.streemApiUpdateCompanyIdentityProviderRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateCompanyIdentityProviderResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Change the current Identity Provider for this Company.  WARNING: this will mean a clean slate of accounts, so previous logins will no longer work
     * Change Identity Provider
     */
    updateCompanyIdentityProvider(companyCodeOrSid, streemApiUpdateCompanyIdentityProviderRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCompanyIdentityProviderRaw({ companyCodeOrSid: companyCodeOrSid, streemApiUpdateCompanyIdentityProviderRequest: streemApiUpdateCompanyIdentityProviderRequest });
            return yield response.value();
        });
    }
    /**
     */
    uploadCompanyCallSourceLogoRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling uploadCompanyCallSourceLogo.');
            }
            if (requestParameters.callSourceSid === null || requestParameters.callSourceSid === undefined) {
                throw new runtime.RequiredError('callSourceSid', 'Required parameter requestParameters.callSourceSid was null or undefined when calling uploadCompanyCallSourceLogo.');
            }
            if (requestParameters.type === null || requestParameters.type === undefined) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling uploadCompanyCallSourceLogo.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/call-source/{call_source_sid}/asset/{type}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"call_source_sid"}}`, encodeURIComponent(String(requestParameters.callSourceSid))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUploadCompanyCallSourceLogoRequestToJSON)(requestParameters.streemApiUploadCompanyCallSourceLogoRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUploadCompanyCallSourceLogoResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    uploadCompanyCallSourceLogo(companyCodeOrSid, callSourceSid, type, streemApiUploadCompanyCallSourceLogoRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.uploadCompanyCallSourceLogoRaw({ companyCodeOrSid: companyCodeOrSid, callSourceSid: callSourceSid, type: type, streemApiUploadCompanyCallSourceLogoRequest: streemApiUploadCompanyCallSourceLogoRequest });
            return yield response.value();
        });
    }
}
exports.CompaniesApi = CompaniesApi;
/**
    * @export
    * @enum {string}
    */
var CreateCompanyAssetOperationType;
(function (CreateCompanyAssetOperationType) {
    CreateCompanyAssetOperationType["LOGO"] = "COMPANY_UPLOAD_TYPE_LOGO";
    CreateCompanyAssetOperationType["WATERMARK"] = "COMPANY_UPLOAD_TYPE_WATERMARK";
    CreateCompanyAssetOperationType["ROOMOUTCOMECONFIG"] = "COMPANY_UPLOAD_TYPE_ROOM_OUTCOME_CONFIG";
    CreateCompanyAssetOperationType["CALLSOURCELOGO"] = "COMPANY_UPLOAD_TYPE_CALL_SOURCE_LOGO";
    CreateCompanyAssetOperationType["INVALID"] = "COMPANY_UPLOAD_TYPE_INVALID";
})(CreateCompanyAssetOperationType = exports.CreateCompanyAssetOperationType || (exports.CreateCompanyAssetOperationType = {}));
/**
    * @export
    * @enum {string}
    */
var ListCompanyApiKeysExpires;
(function (ListCompanyApiKeysExpires) {
    ListCompanyApiKeysExpires["ANY"] = "EXPIRES_ANY";
    ListCompanyApiKeysExpires["NO"] = "EXPIRES_NO";
    ListCompanyApiKeysExpires["YES"] = "EXPIRES_YES";
})(ListCompanyApiKeysExpires = exports.ListCompanyApiKeysExpires || (exports.ListCompanyApiKeysExpires = {}));
/**
    * @export
    * @enum {string}
    */
var ListGroupAvailabilityStatus;
(function (ListGroupAvailabilityStatus) {
    ListGroupAvailabilityStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    ListGroupAvailabilityStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    ListGroupAvailabilityStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
    ListGroupAvailabilityStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    ListGroupAvailabilityStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    ListGroupAvailabilityStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    ListGroupAvailabilityStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
})(ListGroupAvailabilityStatus = exports.ListGroupAvailabilityStatus || (exports.ListGroupAvailabilityStatus = {}));
/**
    * @export
    * @enum {string}
    */
var ListUsersForCompanyUserTypes;
(function (ListUsersForCompanyUserTypes) {
    ListUsersForCompanyUserTypes["UNSPECIFIED"] = "USER_TYPE_UNSPECIFIED";
    ListUsersForCompanyUserTypes["LOGIN"] = "USER_TYPE_LOGIN";
    ListUsersForCompanyUserTypes["SDK"] = "USER_TYPE_SDK";
    ListUsersForCompanyUserTypes["INVITED"] = "USER_TYPE_INVITED";
})(ListUsersForCompanyUserTypes = exports.ListUsersForCompanyUserTypes || (exports.ListUsersForCompanyUserTypes = {}));
/**
    * @export
    * @enum {string}
    */
var UploadCompanyCallSourceLogoType;
(function (UploadCompanyCallSourceLogoType) {
    UploadCompanyCallSourceLogoType["LOGO"] = "COMPANY_UPLOAD_TYPE_LOGO";
    UploadCompanyCallSourceLogoType["WATERMARK"] = "COMPANY_UPLOAD_TYPE_WATERMARK";
    UploadCompanyCallSourceLogoType["ROOMOUTCOMECONFIG"] = "COMPANY_UPLOAD_TYPE_ROOM_OUTCOME_CONFIG";
    UploadCompanyCallSourceLogoType["CALLSOURCELOGO"] = "COMPANY_UPLOAD_TYPE_CALL_SOURCE_LOGO";
    UploadCompanyCallSourceLogoType["INVALID"] = "COMPANY_UPLOAD_TYPE_INVALID";
})(UploadCompanyCallSourceLogoType = exports.UploadCompanyCallSourceLogoType || (exports.UploadCompanyCallSourceLogoType = {}));
//# sourceMappingURL=CompaniesApi.js.map